import { Bell, CircleHelp, ShieldCheck, User } from 'lucide-react'
import { AppPaths } from '@/config/app-paths'
import type { StaffNavContext } from '../staff-nav-context'
import { group, leaf, type StaffNavGroup, type StaffNavNode } from '../nav-node'

export function buildAccountGroup(ctx: StaffNavContext): StaffNavGroup | null {
  const children: StaffNavNode[] = [
    leaf(
      'notifications',
      'My Notifications',
      AppPaths.accountNotifications,
      Bell,
      ['alerts', 'messages'],
    ),
  ]
  if (ctx.showMyAccessNav) {
    children.push(
      leaf('my_access', 'My Access', AppPaths.accountAccess, ShieldCheck, [
        'session',
        'permissions',
      ]),
    )
  }
  children.push(
    leaf('user_guide', 'User Guide', AppPaths.accountHelp, CircleHelp, ['help', 'guide']),
  )
  return group('account', 'Account', User, ['account', 'notifications', 'help'], children)
}
